export const collectDataLabel: string =
  'Estou ciente de que, para melhorar a experiência de uso e o desenvolvimento do produto, o Wida coleta dados durante o uso da plataforma, conforme política de privacidade.'
